import React from 'react';
import Box from '@Atoms/Box';
import ScoreBar from './ScoreBar';

interface StudentRowProps {
  studentName: string;
  score: number;
  maxScore: number;
  percentage: number;
  leftMargin?: number;
  barColor?: string;
}

const StudentRow: React.FC<StudentRowProps> = ({
  studentName,
  score,
  maxScore,
  percentage,
  leftMargin = 16,
  barColor = 'success.light',
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: 2,
      px: 3,
      py: 1,
      alignItems: 'center',
      borderTop: 1,
      borderColor: 'divider',
    }}
  >
    <Box sx={{ gridColumn: 'span 5', ml: leftMargin }}>
      <Box
        component="span"
        sx={{
          fontSize: '0.75rem',
          color: 'text.primary',
        }}
      >
        {studentName}
      </Box>
    </Box>
    <Box
      sx={{
        gridColumn: 'span 2',
        textAlign: 'center',
        fontSize: '0.75rem',
        color: 'text.secondary',
      }}
    >
      {score}/{maxScore}
    </Box>
    <Box sx={{ gridColumn: 'span 5' }}>
      <ScoreBar percentage={percentage} color={barColor} height={24} />
    </Box>
  </Box>
);

export default StudentRow;
